/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var shared_pb = require('./shared_pb.js');
goog.exportSymbol('proto.fleet.AllStationsRequest', null, global);
goog.exportSymbol('proto.fleet.ClosestStationRequest', null, global);
goog.exportSymbol('proto.fleet.FavoriteDestinationsRequest', null, global);
goog.exportSymbol('proto.fleet.FilteredStationRequest', null, global);
goog.exportSymbol('proto.fleet.Station', null, global);
goog.exportSymbol('proto.fleet.StationRequest', null, global);
goog.exportSymbol('proto.fleet.StationResponse', null, global);
goog.exportSymbol('proto.fleet.StationResponseOrErrorResponse', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.FilteredStationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.FilteredStationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.FilteredStationRequest.displayName = 'proto.fleet.FilteredStationRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.FilteredStationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.FilteredStationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.FilteredStationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.FilteredStationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    cursor: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.FilteredStationRequest}
 */
proto.fleet.FilteredStationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.FilteredStationRequest;
  return proto.fleet.FilteredStationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.FilteredStationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.FilteredStationRequest}
 */
proto.fleet.FilteredStationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.FilteredStationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.FilteredStationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.FilteredStationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.FilteredStationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCursor();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.fleet.FilteredStationRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.FilteredStationRequest.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 cursor = 2;
 * @return {number}
 */
proto.fleet.FilteredStationRequest.prototype.getCursor = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.fleet.FilteredStationRequest.prototype.setCursor = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.FavoriteDestinationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.FavoriteDestinationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.FavoriteDestinationsRequest.displayName = 'proto.fleet.FavoriteDestinationsRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.FavoriteDestinationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.FavoriteDestinationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.FavoriteDestinationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.FavoriteDestinationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    originStationId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    numFavorites: jspb.Message.getFieldWithDefault(msg, 2, 0),
    getSiteFavorites: jspb.Message.getFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.FavoriteDestinationsRequest}
 */
proto.fleet.FavoriteDestinationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.FavoriteDestinationsRequest;
  return proto.fleet.FavoriteDestinationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.FavoriteDestinationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.FavoriteDestinationsRequest}
 */
proto.fleet.FavoriteDestinationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOriginStationId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumFavorites(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGetSiteFavorites(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.FavoriteDestinationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.FavoriteDestinationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.FavoriteDestinationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.FavoriteDestinationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOriginStationId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getNumFavorites();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getGetSiteFavorites();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional int32 origin_station_id = 1;
 * @return {number}
 */
proto.fleet.FavoriteDestinationsRequest.prototype.getOriginStationId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.FavoriteDestinationsRequest.prototype.setOriginStationId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 num_favorites = 2;
 * @return {number}
 */
proto.fleet.FavoriteDestinationsRequest.prototype.getNumFavorites = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.fleet.FavoriteDestinationsRequest.prototype.setNumFavorites = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool get_site_favorites = 3;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.FavoriteDestinationsRequest.prototype.getGetSiteFavorites = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.fleet.FavoriteDestinationsRequest.prototype.setGetSiteFavorites = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.AllStationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.AllStationsRequest.repeatedFields_, null);
};
goog.inherits(proto.fleet.AllStationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.AllStationsRequest.displayName = 'proto.fleet.AllStationsRequest';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.AllStationsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.AllStationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.AllStationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.AllStationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AllStationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreaIdsList: jspb.Message.getRepeatedField(msg, 1)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.AllStationsRequest}
 */
proto.fleet.AllStationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.AllStationsRequest;
  return proto.fleet.AllStationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.AllStationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.AllStationsRequest}
 */
proto.fleet.AllStationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setOperatingAreaIdsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.AllStationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.AllStationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.AllStationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AllStationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreaIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 operating_area_ids = 1;
 * @return {!Array<number>}
 */
proto.fleet.AllStationsRequest.prototype.getOperatingAreaIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/** @param {!Array<number>} value */
proto.fleet.AllStationsRequest.prototype.setOperatingAreaIdsList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!number} value
 * @param {number=} opt_index
 */
proto.fleet.AllStationsRequest.prototype.addOperatingAreaIds = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


proto.fleet.AllStationsRequest.prototype.clearOperatingAreaIdsList = function() {
  this.setOperatingAreaIdsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.ClosestStationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.ClosestStationRequest.repeatedFields_, null);
};
goog.inherits(proto.fleet.ClosestStationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.ClosestStationRequest.displayName = 'proto.fleet.ClosestStationRequest';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.ClosestStationRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.ClosestStationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.ClosestStationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.ClosestStationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.ClosestStationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    operatingAreaIdsList: jspb.Message.getRepeatedField(msg, 1),
    targetLatLon: (f = msg.getTargetLatLon()) && shared_pb.LatLon.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.ClosestStationRequest}
 */
proto.fleet.ClosestStationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.ClosestStationRequest;
  return proto.fleet.ClosestStationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.ClosestStationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.ClosestStationRequest}
 */
proto.fleet.ClosestStationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setOperatingAreaIdsList(value);
      break;
    case 2:
      var value = new shared_pb.LatLon;
      reader.readMessage(value,shared_pb.LatLon.deserializeBinaryFromReader);
      msg.setTargetLatLon(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.ClosestStationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.ClosestStationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.ClosestStationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.ClosestStationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperatingAreaIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
  f = message.getTargetLatLon();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.LatLon.serializeBinaryToWriter
    );
  }
};


/**
 * repeated int32 operating_area_ids = 1;
 * @return {!Array<number>}
 */
proto.fleet.ClosestStationRequest.prototype.getOperatingAreaIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/** @param {!Array<number>} value */
proto.fleet.ClosestStationRequest.prototype.setOperatingAreaIdsList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!number} value
 * @param {number=} opt_index
 */
proto.fleet.ClosestStationRequest.prototype.addOperatingAreaIds = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


proto.fleet.ClosestStationRequest.prototype.clearOperatingAreaIdsList = function() {
  this.setOperatingAreaIdsList([]);
};


/**
 * optional LatLon target_lat_lon = 2;
 * @return {?proto.fleet.LatLon}
 */
proto.fleet.ClosestStationRequest.prototype.getTargetLatLon = function() {
  return /** @type{?proto.fleet.LatLon} */ (
    jspb.Message.getWrapperField(this, shared_pb.LatLon, 2));
};


/** @param {?proto.fleet.LatLon|undefined} value */
proto.fleet.ClosestStationRequest.prototype.setTargetLatLon = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.fleet.ClosestStationRequest.prototype.clearTargetLatLon = function() {
  this.setTargetLatLon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.ClosestStationRequest.prototype.hasTargetLatLon = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.StationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.StationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.StationRequest.displayName = 'proto.fleet.StationRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.StationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.StationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.StationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.StationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.StationRequest}
 */
proto.fleet.StationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.StationRequest;
  return proto.fleet.StationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.StationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.StationRequest}
 */
proto.fleet.StationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.StationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.StationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.StationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.StationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.fleet.StationRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.StationRequest.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.StationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.StationResponse.repeatedFields_, null);
};
goog.inherits(proto.fleet.StationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.StationResponse.displayName = 'proto.fleet.StationResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.StationResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.StationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.StationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.StationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.StationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    stationsList: jspb.Message.toObjectList(msg.getStationsList(),
    proto.fleet.Station.toObject, includeInstance),
    cursor: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.StationResponse}
 */
proto.fleet.StationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.StationResponse;
  return proto.fleet.StationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.StationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.StationResponse}
 */
proto.fleet.StationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.Station;
      reader.readMessage(value,proto.fleet.Station.deserializeBinaryFromReader);
      msg.addStations(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.StationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.StationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.StationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.StationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fleet.Station.serializeBinaryToWriter
    );
  }
  f = message.getCursor();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated Station stations = 1;
 * @return {!Array<!proto.fleet.Station>}
 */
proto.fleet.StationResponse.prototype.getStationsList = function() {
  return /** @type{!Array<!proto.fleet.Station>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.Station, 1));
};


/** @param {!Array<!proto.fleet.Station>} value */
proto.fleet.StationResponse.prototype.setStationsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fleet.Station=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.Station}
 */
proto.fleet.StationResponse.prototype.addStations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet.Station, opt_index);
};


proto.fleet.StationResponse.prototype.clearStationsList = function() {
  this.setStationsList([]);
};


/**
 * optional int32 cursor = 2;
 * @return {number}
 */
proto.fleet.StationResponse.prototype.getCursor = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.fleet.StationResponse.prototype.setCursor = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.Station = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.Station.repeatedFields_, null);
};
goog.inherits(proto.fleet.Station, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.Station.displayName = 'proto.fleet.Station';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.Station.repeatedFields_ = [8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.Station.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.Station.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.Station} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.Station.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    nickname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    latLon: (f = msg.getLatLon()) && shared_pb.LatLon.toObject(includeInstance, f),
    address: (f = msg.getAddress()) && shared_pb.Address.toObject(includeInstance, f),
    disabled: jspb.Message.getFieldWithDefault(msg, 5, false),
    disabledDate: jspb.Message.getFieldWithDefault(msg, 6, ""),
    operatingAreaId: jspb.Message.getFieldWithDefault(msg, 7, 0),
    linksToList: jspb.Message.getRepeatedField(msg, 8),
    linksFromList: jspb.Message.getRepeatedField(msg, 9)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.Station}
 */
proto.fleet.Station.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.Station;
  return proto.fleet.Station.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.Station} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.Station}
 */
proto.fleet.Station.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 3:
      var value = new shared_pb.LatLon;
      reader.readMessage(value,shared_pb.LatLon.deserializeBinaryFromReader);
      msg.setLatLon(value);
      break;
    case 4:
      var value = new shared_pb.Address;
      reader.readMessage(value,shared_pb.Address.deserializeBinaryFromReader);
      msg.setAddress(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisabled(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisabledDate(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOperatingAreaId(value);
      break;
    case 8:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setLinksToList(value);
      break;
    case 9:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setLinksFromList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.Station.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.Station.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.Station} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.Station.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLatLon();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      shared_pb.LatLon.serializeBinaryToWriter
    );
  }
  f = message.getAddress();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      shared_pb.Address.serializeBinaryToWriter
    );
  }
  f = message.getDisabled();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getDisabledDate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOperatingAreaId();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getLinksToList();
  if (f.length > 0) {
    writer.writePackedInt32(
      8,
      f
    );
  }
  f = message.getLinksFromList();
  if (f.length > 0) {
    writer.writePackedInt32(
      9,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.fleet.Station.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.Station.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string nickname = 2;
 * @return {string}
 */
proto.fleet.Station.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.Station.prototype.setNickname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional LatLon lat_lon = 3;
 * @return {?proto.fleet.LatLon}
 */
proto.fleet.Station.prototype.getLatLon = function() {
  return /** @type{?proto.fleet.LatLon} */ (
    jspb.Message.getWrapperField(this, shared_pb.LatLon, 3));
};


/** @param {?proto.fleet.LatLon|undefined} value */
proto.fleet.Station.prototype.setLatLon = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.fleet.Station.prototype.clearLatLon = function() {
  this.setLatLon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.Station.prototype.hasLatLon = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Address address = 4;
 * @return {?proto.fleet.Address}
 */
proto.fleet.Station.prototype.getAddress = function() {
  return /** @type{?proto.fleet.Address} */ (
    jspb.Message.getWrapperField(this, shared_pb.Address, 4));
};


/** @param {?proto.fleet.Address|undefined} value */
proto.fleet.Station.prototype.setAddress = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.fleet.Station.prototype.clearAddress = function() {
  this.setAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.Station.prototype.hasAddress = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool disabled = 5;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.fleet.Station.prototype.getDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 5, false));
};


/** @param {boolean} value */
proto.fleet.Station.prototype.setDisabled = function(value) {
  jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string disabled_date = 6;
 * @return {string}
 */
proto.fleet.Station.prototype.getDisabledDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.fleet.Station.prototype.setDisabledDate = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 operating_area_id = 7;
 * @return {number}
 */
proto.fleet.Station.prototype.getOperatingAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.fleet.Station.prototype.setOperatingAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * repeated int32 links_to = 8;
 * @return {!Array<number>}
 */
proto.fleet.Station.prototype.getLinksToList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 8));
};


/** @param {!Array<number>} value */
proto.fleet.Station.prototype.setLinksToList = function(value) {
  jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {!number} value
 * @param {number=} opt_index
 */
proto.fleet.Station.prototype.addLinksTo = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


proto.fleet.Station.prototype.clearLinksToList = function() {
  this.setLinksToList([]);
};


/**
 * repeated int32 links_from = 9;
 * @return {!Array<number>}
 */
proto.fleet.Station.prototype.getLinksFromList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 9));
};


/** @param {!Array<number>} value */
proto.fleet.Station.prototype.setLinksFromList = function(value) {
  jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {!number} value
 * @param {number=} opt_index
 */
proto.fleet.Station.prototype.addLinksFrom = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


proto.fleet.Station.prototype.clearLinksFromList = function() {
  this.setLinksFromList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.StationResponseOrErrorResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fleet.StationResponseOrErrorResponse.oneofGroups_);
};
goog.inherits(proto.fleet.StationResponseOrErrorResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.StationResponseOrErrorResponse.displayName = 'proto.fleet.StationResponseOrErrorResponse';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fleet.StationResponseOrErrorResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.fleet.StationResponseOrErrorResponse.StationResponseOneOfCase = {
  STATION_RESPONSE_ONE_OF_NOT_SET: 0,
  STATION_RESPONSE: 1,
  ERROR: 2
};

/**
 * @return {proto.fleet.StationResponseOrErrorResponse.StationResponseOneOfCase}
 */
proto.fleet.StationResponseOrErrorResponse.prototype.getStationResponseOneOfCase = function() {
  return /** @type {proto.fleet.StationResponseOrErrorResponse.StationResponseOneOfCase} */(jspb.Message.computeOneofCase(this, proto.fleet.StationResponseOrErrorResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.StationResponseOrErrorResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.StationResponseOrErrorResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.StationResponseOrErrorResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.StationResponseOrErrorResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    stationResponse: (f = msg.getStationResponse()) && proto.fleet.StationResponse.toObject(includeInstance, f),
    error: (f = msg.getError()) && shared_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.StationResponseOrErrorResponse}
 */
proto.fleet.StationResponseOrErrorResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.StationResponseOrErrorResponse;
  return proto.fleet.StationResponseOrErrorResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.StationResponseOrErrorResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.StationResponseOrErrorResponse}
 */
proto.fleet.StationResponseOrErrorResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.StationResponse;
      reader.readMessage(value,proto.fleet.StationResponse.deserializeBinaryFromReader);
      msg.setStationResponse(value);
      break;
    case 2:
      var value = new shared_pb.Error;
      reader.readMessage(value,shared_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.StationResponseOrErrorResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.StationResponseOrErrorResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.StationResponseOrErrorResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.StationResponseOrErrorResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStationResponse();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.StationResponse.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      shared_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional StationResponse station_response = 1;
 * @return {?proto.fleet.StationResponse}
 */
proto.fleet.StationResponseOrErrorResponse.prototype.getStationResponse = function() {
  return /** @type{?proto.fleet.StationResponse} */ (
    jspb.Message.getWrapperField(this, proto.fleet.StationResponse, 1));
};


/** @param {?proto.fleet.StationResponse|undefined} value */
proto.fleet.StationResponseOrErrorResponse.prototype.setStationResponse = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.fleet.StationResponseOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.StationResponseOrErrorResponse.prototype.clearStationResponse = function() {
  this.setStationResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.StationResponseOrErrorResponse.prototype.hasStationResponse = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Error error = 2;
 * @return {?proto.fleet.Error}
 */
proto.fleet.StationResponseOrErrorResponse.prototype.getError = function() {
  return /** @type{?proto.fleet.Error} */ (
    jspb.Message.getWrapperField(this, shared_pb.Error, 2));
};


/** @param {?proto.fleet.Error|undefined} value */
proto.fleet.StationResponseOrErrorResponse.prototype.setError = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.fleet.StationResponseOrErrorResponse.oneofGroups_[0], value);
};


proto.fleet.StationResponseOrErrorResponse.prototype.clearError = function() {
  this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.StationResponseOrErrorResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.fleet);
